import { render, staticRenderFns } from "./duplic.vue?vue&type=template&id=3410d440&"
import script from "./duplic.vue?vue&type=script&lang=js&"
export * from "./duplic.vue?vue&type=script&lang=js&"
import style0 from "./duplic.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports